module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_05@2x-0c0db17dbf7806609b3c9629a99b07c8.webp";